"use client"

import { alpha, createTheme } from "@mui/material/styles"

export const RRHH_ESTADOS_LABORALES = [
  { value: "ACTIVO", label: "Activo" },
  { value: "INACTIVO", label: "Inactivo" },
  { value: "LICENCIA", label: "Licencia" },
  { value: "BAJA", label: "Baja" },
]

export const RRHH_TIPOS_JORNADA = [
  { value: "FULL_TIME", label: "Full time" },
  { value: "PART_TIME", label: "Part time" },
  { value: "ROTATIVO", label: "Rotativo" },
  { value: "NOCTURNO", label: "Nocturno" },
  { value: "OTRO", label: "Otro" },
]

export const RRHH_TIPOS_FICHAJE = [
  { value: "INGRESO", label: "Ingreso" },
  { value: "EGRESO", label: "Egreso" },
  { value: "INICIO_DESCANSO", label: "Inicio descanso" },
  { value: "FIN_DESCANSO", label: "Fin descanso" },
]

export const RRHH_ESTADOS_ASISTENCIA = [
  { value: "PRESENTE", label: "Presente" },
  { value: "TARDE", label: "Tarde" },
  { value: "AUSENTE", label: "Ausente" },
  { value: "INCOMPLETO", label: "Incompleto" },
  { value: "LICENCIA", label: "Licencia" },
  { value: "FRANCO", label: "Franco" },
  { value: "FERIADO", label: "Feriado" },
  { value: "SIN_TURNO", label: "Sin turno" },
]

export const RRHH_ESTADOS_LIQUIDACION = [
  { value: "BORRADOR", label: "Borrador" },
  { value: "APROBADA", label: "Aprobada" },
  { value: "PAGADA", label: "Pagada" },
]

export const RRHH_TIPOS_CONCEPTO_LIQUIDACION = [
  { value: "HABER", label: "Haber" },
  { value: "DESCUENTO", label: "Descuento" },
  { value: "INFORMATIVO", label: "Informativo" },
]

export const RRHH_CATEGORIAS_NOVEDAD = [
  { value: "BONO", label: "Bono" },
  { value: "ADELANTO", label: "Adelanto" },
  { value: "AJUSTE", label: "Ajuste" },
  { value: "LICENCIA", label: "Licencia" },
  { value: "COMISION", label: "Comisión" },
  { value: "OTRO", label: "Otro" },
]

export const rrhhTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#5b5b5f",
    },
    secondary: {
      main: "rgb(244, 177, 14)",
    },
    background: {
      default: "#f8f9fa",
      paper: "#ffffff",
    },
    text: {
      primary: "#2d3748",
      secondary: "#718096",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    button: {
      textTransform: "none",
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
          boxShadow: "none",
          fontWeight: 500,
          "&:hover": {
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          borderRadius: 6,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 8,
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          borderRadius: 8,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: alpha("#5b5b5f", 0.08),
          },
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: "none",
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#5b5b5f",
            color: "#fff",
            borderBottom: "none",
            borderRadius: "8px 8px 0 0",
            padding: "0 16px",
            minHeight: "56px !important",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: "white !important",
            fontWeight: 600,
            fontSize: "0.875rem",
          },
          "& .MuiDataGrid-columnHeaderTitleContainer": {
            padding: "0 8px",
          },
          "& .MuiDataGrid-menuIconButton": {
            color: "rgba(255, 255, 255, 0.7) !important",
            "&:hover": {
              color: "white !important",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
          },
          "& .MuiDataGrid-iconButtonContainer": {
            color: "white !important",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "1px solid rgba(224, 224, 224, 0.5)",
            padding: "0 16px",
            fontSize: "0.875rem",
          },
          "& .MuiDataGrid-row": {
            "&:nth-of-type(even)": {
              backgroundColor: "rgba(0, 0, 0, 0.02)",
            },
            "&:hover": {
              backgroundColor: "rgba(66, 153, 225, 0.08)",
              transition: "background 0.2s ease",
            },
            transition: "background 0.2s ease",
          },
          "& .MuiDataGrid-footerContainer": {
            display: "none !important",
          },
          "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
            width: "8px",
            height: "8px",
          },
          "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
            background: "#f1f1f1",
            borderRadius: "10px",
          },
          "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
            backgroundColor: "#c1c1c1",
            borderRadius: "10px",
          },
        },
      },
    },
  },
})

export const getEstadoLaboralMeta = (estadoLaboral) => {
  switch (String(estadoLaboral || "").toUpperCase()) {
    case "ACTIVO":
      return { label: "Activo", color: "#2e7d32", backgroundColor: alpha("#2e7d32", 0.12) }
    case "LICENCIA":
      return { label: "Licencia", color: "#9a6700", backgroundColor: alpha("#f59e0b", 0.16) }
    case "BAJA":
      return { label: "Baja", color: "#c62828", backgroundColor: alpha("#c62828", 0.12) }
    case "INACTIVO":
      return { label: "Inactivo", color: "#475569", backgroundColor: alpha("#64748b", 0.14) }
    default:
      return { label: estadoLaboral || "Sin estado", color: "#475569", backgroundColor: alpha("#64748b", 0.14) }
  }
}

export const getEstadoAsistenciaMeta = (estadoAsistencia) => {
  switch (String(estadoAsistencia || "").toUpperCase()) {
    case "PRESENTE":
      return { label: "Presente", color: "#166534", backgroundColor: alpha("#22c55e", 0.14) }
    case "TARDE":
      return { label: "Tarde", color: "#9a6700", backgroundColor: alpha("#f59e0b", 0.16) }
    case "AUSENTE":
      return { label: "Ausente", color: "#b91c1c", backgroundColor: alpha("#ef4444", 0.14) }
    case "INCOMPLETO":
      return { label: "Incompleto", color: "#7c2d12", backgroundColor: alpha("#fb923c", 0.18) }
    case "LICENCIA":
      return { label: "Licencia", color: "#9a6700", backgroundColor: alpha("#f59e0b", 0.16) }
    case "FRANCO":
      return { label: "Franco", color: "#1d4ed8", backgroundColor: alpha("#3b82f6", 0.14) }
    case "FERIADO":
      return { label: "Feriado", color: "#7e22ce", backgroundColor: alpha("#a855f7", 0.14) }
    case "SIN_TURNO":
      return { label: "Sin turno", color: "#475569", backgroundColor: alpha("#64748b", 0.14) }
    default:
      return { label: estadoAsistencia || "Sin estado", color: "#475569", backgroundColor: alpha("#64748b", 0.14) }
  }
}

export const getTipoFichajeMeta = (tipoEvento) => {
  switch (String(tipoEvento || "").toUpperCase()) {
    case "INGRESO":
      return { label: "Ingreso", color: "#166534", backgroundColor: alpha("#22c55e", 0.14) }
    case "EGRESO":
      return { label: "Egreso", color: "#b91c1c", backgroundColor: alpha("#ef4444", 0.14) }
    case "INICIO_DESCANSO":
      return { label: "Inicio descanso", color: "#9a6700", backgroundColor: alpha("#f59e0b", 0.16) }
    case "FIN_DESCANSO":
      return { label: "Fin descanso", color: "#1d4ed8", backgroundColor: alpha("#3b82f6", 0.14) }
    default:
      return { label: tipoEvento || "Sin tipo", color: "#475569", backgroundColor: alpha("#64748b", 0.14) }
  }
}

export const getEstadoLiquidacionMeta = (estadoLiquidacion) => {
  switch (String(estadoLiquidacion || "").toUpperCase()) {
    case "BORRADOR":
      return { label: "Borrador", color: "#92400e", backgroundColor: alpha("#f59e0b", 0.16) }
    case "APROBADA":
      return { label: "Aprobada", color: "#1d4ed8", backgroundColor: alpha("#3b82f6", 0.14) }
    case "PAGADA":
      return { label: "Pagada", color: "#166534", backgroundColor: alpha("#22c55e", 0.14) }
    default:
      return { label: estadoLiquidacion || "Sin estado", color: "#475569", backgroundColor: alpha("#64748b", 0.14) }
  }
}

export const formatFecha = (value) => {
  if (!value) return "-"
  const fecha = new Date(value)
  if (Number.isNaN(fecha.getTime())) return "-"
  return fecha.toLocaleDateString("es-AR")
}

export const formatPeriodoMensual = (value) => {
  if (!value || !/^\d{4}-\d{2}$/.test(String(value))) return "-"
  const [anio, mes] = String(value).split("-")
  return `${mes}/${anio}`
}

export const formatHora = (value) => {
  if (!value) return "-"
  return String(value).slice(0, 5)
}

export const formatFechaHora = (value) => {
  if (!value) return "-"
  const fecha = new Date(value)
  if (Number.isNaN(fecha.getTime())) return "-"
  return fecha.toLocaleString("es-AR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  })
}

export const formatDuracionMinutos = (value) => {
  const minutos = Number(value)
  if (!Number.isFinite(minutos)) return "-"
  const horas = Math.floor(minutos / 60)
  const resto = minutos % 60
  if (horas === 0) return `${resto} min`
  if (resto === 0) return `${horas} h`
  return `${horas} h ${resto} min`
}

export const formatCurrency = (value) => {
  if (value === undefined || value === null || value === "") return "-"
  const numero = Number(value)
  if (!Number.isFinite(numero)) return "-"
  return new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(numero)
}

export const getEmpleadoNombreCompleto = (empleadoLike = {}) => {
  const empleadoSafe = empleadoLike || {}
  const entidad = empleadoSafe.entidad || empleadoSafe
  const nombre = String(entidad.descripcion || "").trim()
  const apellido = String(entidad.apellido || "").trim()
  return [apellido, nombre].filter(Boolean).join(", ") || "Sin nombre"
}

export const getSupervisorNombre = (supervisor = {}) => {
  const supervisorSafe = supervisor || {}
  const nombre = String(supervisorSafe.descripcion || "").trim()
  const apellido = String(supervisorSafe.apellido || "").trim()
  return [apellido, nombre].filter(Boolean).join(", ") || "-"
}

export const extractErrorMessage = (error, fallback = "Ocurrió un error inesperado.") => {
  return (
    error?.response?.data?.message ||
    error?.message ||
    fallback
  )
}
